<template>
    <box :hideable="true">
        <h3 slot="header">
            <i class="fas fa-sign-in-alt"></i> Input
        </h3>

        <div slot="body">

            <div class="row mb-2">

                <div class="col-4">
                    <label for="schemeId">Scheme</label>

                    <div class="input-group">
                        <div class="input-group-prepend">
                            <div class="input-group-text">
                                <i class="fas fa-cubes"></i>
                            </div>
                        </div>
                        <dropdown v-if="schemes"
                                  v-model="newSchemeId"
                                  name="schemeId"
                                  :textField="'value'"
                                  :valueField="'key'"
                                  :placeholder="'--select scheme--'"
                                  :datasource="schemes"
                        />
                    </div>
                </div>

                <div class="col-auto button-container">
                    <button class="btn btn-secondary mt-auto" @click="openScheme" :disabled="!schemeId">
                        <i class="fas fa-external-link-alt"></i> Open scheme
                    </button>

                    <button class="btn btn-secondary mt-auto" @click="validateScheme" :disabled="!schemeId">
                        <i class="fas fa-check-circle"></i> {{resource('Operator_Test_ValidateScheme_Button')}}
                    </button>
                </div>

            </div>

            <div class="row mb-2">
                <div class="col-12">
                    <json-editor v-model="json" @error="validJson = !$event"/>
                </div>
            </div>

            <div class="row mb-2">
                <div class="col-12">
                    <button class="btn btn-primary" @click="runTest()" :disabled="!testIsValid">
                        <i class="fas fa-vial"></i> Run test
                    </button>
                </div>
            </div>

        </div>
    </box>
</template>

<script>

    //Util
    import api from '../api';
    import {bootstrapDangerGrowl} from '../../../Util/growler';
    import {validateScheme} from "@modules/Operator/util";

    //Components
    import Dropdown from '../../../Components/Inputs/Dropdown.vue';
    import BootstrapBox from '../../../Components/Util/BootstrapBox.vue';
    import JsonEditor from '../../../Components/Util/JsonEditor.vue';

    import resourceMixin from "@core/Util/Mixins/resources";

    export default {
        name: 'operator-test',
        components: {
            Dropdown,
            'Box': BootstrapBox,
            JsonEditor
        },
        mixins: [resourceMixin],
        created() {
            const vm = this;

            api.getSchemes().then(
                (schemes) => {
                    vm.schemes = schemes;
                },
                bootstrapDangerGrowl
            );
        },
        methods: {
            runTest() {
                const vm = this;
                vm.$emit('loading');
                api.clearCache().then(
                    () => {
                        api.runScheme(vm.schemeId, vm.json).then(
                            (result) => {
                                vm.$emit('result', result.value);
                            },
                            (error) => {
                                //500 should have an exception.
                                if(error.code >= 500 && error.code < 600) {
                                    bootstrapDangerGrowl(`${error.code}: ${error.type}<br />${error.value.ExceptionMessage}`);
                                }
                                else {
                                    bootstrapDangerGrowl(`${error.code}: ${error.type}<br />${error.value.Message}`);
                                }
                                vm.$emit('done');
                            }
                        );
                    },
                    bootstrapDangerGrowl
                );

            },
            openScheme() {
                const baseUrl = '/Operator/EditRevision/'
                openInNewTab(`${baseUrl}${this.schemeId}`);

                function openInNewTab(url) {
                    var win = window.open(url, '_blank');
                    win.focus();
                }
            },
            async validateScheme(){
                try{
                    await api.clearCache()
                }
                catch(e) {
                    bootstrapDangerGrowl(e);
                    return;
                }

                await validateScheme(this.schemeId);
            }
        },
        computed: {
            testIsValid() {
                return this.validJson && this.schemeId;
            }
        },
        watch: {
            newSchemeId(value) {
                if(value != this.schemeId) {
                    this.$emit('change-scheme', value);
                }
            }
        },
        data() {
            return {
                testResult: null,
                schemes: null,
                newSchemeId: null,
                json: {},
                validJson: true
            };
        },
        props: {
            schemeId: {
                type: String,
                default: null
            }
        }
    };
</script>

<style lang="scss" scoped>
    .button-container {
        display: flex;
        column-gap: 10px;
    }
</style>